<template>
    <div class="page__content portals">
        <div class="columns">
            <div class="column">
                <h2 class="page__headline">{{ $t('portals.title') }}</h2>
                <div class="max-w-3xl">
                    <p class="mb-2 mt-4">{{ $t('portals.text') }}</p>
                    <p class="mb-2">{{ $t('portals.provisionHeadline') }}</p>
                    <p class="mb-2">{{ $t('portals.provisionText') }}</p>
                    <p>{{ $t('portals.provisionInfo') }}</p>
                </div>
            </div>
        </div>

<!--        <div class="columns">-->
<!--            <div class="column">-->
<!--                <div class="portals__table-toolbar">-->
<!--                    <button-->
<!--                        class="button is-primary"-->
<!--                        @click="toggleModal"-->
<!--                        :disabled="isCreateButtonDisabled"-->
<!--                    >-->
<!--                        {{ $t('portals.form.create') }}-->
<!--                    </button>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

        <div v-if="allPortals" class="columns">
            <div class="column is-12 mt-5">
                <PortalsTable
                    :portals="allPortals"
                    :portal-members="portalMembers"
                    :get-portal-name="getPortalName"
                    :campsites="campsites"
                    :documents-accepted="documentsAccepted"
                    @update="update"
                />
            </div>
        </div>


        <div class="modal is-active" v-if="showModal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        {{ modalTitle }}
                    </p>
                    <button class="delete" @click="toggleModal"/>
                </header>
                <section class="modal-card-body">
                    <template v-for="field in form">
                        <div
                            :key="form.name"
                            v-if="!field.isHidden"
                            class="column"
                        >
                            <label
                                :for="field.key"
                                class="label"
                            >
                                {{ field.name }}
                            </label>

                            <div class="portals__form-field">
                                <template v-if="field.type === 'select'">
                                    <multiselect
                                        :id="field.key"
                                        :name="field.key"
                                        v-model="field.value"
                                        :options="field.options()"
                                        :multiple="false"
                                        :searchable="false"
                                        :hide-selected="true"
                                        :placeholder="field.name"
                                        :close-on-select="true"
                                        selectLabel=""
                                        label="name"
                                        track-by="name"
                                    />
                                </template>
                                <template v-else-if="field.type === 'date'">
                                    <datepicker
                                        class="time-period-input"
                                        :placeholder="$t('generic.calendar.placeholder')"
                                        :config="pickerConfig"
                                        v-model="field.value"
                                    >
                                        <a class="button" data-toggle><i class="fa fa-calendar"></i></a>
                                    </datepicker>
                                </template>
                                <template v-else>
                                    <input
                                        :id="field.key"
                                        class="input"
                                        v-model="field.value"
                                        :placeholder="field.name"
                                        :type="field.type"
                                    >
                                </template>
                            </div>
                        </div>
                    </template>
                </section>
                <footer class="modal-card-foot">
                    <div class="block ml-auto">
                        <button class="button is-link" @click.prevent="toggleModal">
                            {{ $t('generic.cancel') }}
                        </button>
                        <button
                            class="button is-primary"
                            :class="{'is-disabled': isFormInvalid }"
                            @click.prevent="savePortal"
                        >
                            {{ $t('generic.save') }}
                        </button>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Datepicker from 'vue-bulma-datepicker';
import moment from 'moment';
import { Api } from '../../../api';
import { AppModel } from '../../../models';
import { PortalsTable, SortableTableHead } from '../../components';
import { EventBus } from '../../../utils';

export default {
    name: 'portals',
    components: {
        Multiselect,
        Datepicker,
        SortableTableHead,
        PortalsTable,
    },
    data() {
        return {
            isCreateButtonDisabled: false,
            documentsAccepted: false,
            moment,
            isEditMode: false,
            isLoading: true,
            allPortals: null,
            portalMembers: null,
            selectedPortalId: null,
            portals: [],
            campsites: [],
            form: {
                portal: {
                    key: 'portal_id',
                    name: this.$t('portals.form.portal'),
                    value: null,
                    valueKey: 'id',
                    type: 'select',
                    options: this.getPortals,
                    isHidden: false,
                },
                campsite: {
                    key: 'campsite_id',
                    name: this.$t('portals.form.campsite'),
                    valueKey: 'id',
                    value: null,
                    type: 'select',
                    options: this.getCampsites,
                    isHidden: false,
                },
                valid_from: {
                    key: 'valid_from',
                    name: this.$t('portals.form.valid_from'),
                    value: null,
                    type: 'date',
                    showDatePicker: false,
                    isHidden: true,
                },
                valid_to: {
                    key: 'valid_to',
                    name: this.$t('portals.form.valid_to'),
                    value: null,
                    type: 'date',
                    showDatePicker: false,
                    isHidden: true,
                },
                allotment: {
                    key: 'allotment',
                    name: this.$t('portals.form.amount'),
                    value: null,
                    type: 'number',
                    isHidden: true,
                },
            },
            pickerConfig: AppModel.datepickerOptions,
            showModal: false,
            tableHeader: [
                'portals.table.portal',
                'portals.table.active',
                'portals.table.type',
                'portals.table.timeframe',
                // 'portals.table.amount',
                'portals.table.state',
                'portals.table.edit',
            ],
        };
    },
    watch: {
        form: {
            handler(form) {
                if(!form.portal.value) {
                    return null;
                }

                const portal = form.portal.value;

                this.form.valid_from.isHidden = !portal.allow_periods;
                this.form.valid_to.isHidden = !portal.allow_periods;
                this.form.allotment.isHidden = !(this.form.campsite.value && portal.allow_allotments);

                this.form.allotment.value = Math.abs(this.form.allotment.value);
            },
            deep: true,
        },
    },
    async created() {
        EventBus.$on(EventBus.BOOTSTRAP_DONE, async() => {
            await this.update();
        });

        if(AppModel.activeCampground) {
            await this.update();
        }

        this.moment.locale(AppModel.lang);
    },
    computed: {
        isFormInvalid() {
            return this.form.portal.value === '' || this.form.portal.value === null;
        },
        modalTitle() {
            return this.isEditMode ? this.$t('portals.form.edit') : this.$t('portals.form.select');
        },
    },
    methods: {
        async update() {
            await this.fetchDocuments();
            await this.fetchCampgroundPortals();
            await this.fetchPortals();

            this.isCreateButtonDisabled = !AppModel.activeCampground.published;
        },
        async fetchDocuments() {
            if(AppModel.activeCampground) {
                const docs = (await Api.documents.fetch()).data.legal_documents;

                this.documentsAccepted = !(docs.to_accept && docs.to_accept.length > 0);
            }
        },
        async fetchPortals() {
            if(AppModel.activeCampground) {
                this.allPortals = (await Api.portals.fetch()).data;
            }
        },
        async fetchCampgroundPortals() {
            if(AppModel.activeCampground) {
                const portals = (await Api.portalMembers.fetch()).data;

                this.portalMembers = portals;
                this.portals = portals.filter(
                    (portal) => portal.campground_slug === AppModel.activeCampground.slug,
                );
                this.campsites = (await Api.campsites.fetchCampsites()).data;
                this.isLoading = false;
            } else {
                setTimeout(async() => {
                    await this.fetchCampgroundPortals();
                }, 300);
            }
        },
        resetForm() {
            Object.values(this.form).forEach((formElement) => {
                formElement.value = null;

                if(formElement.key !== 'portal_id' && formElement.key !== 'campsite_id') {
                    formElement.isHidden = true;
                }
            });
        },
        getPortalName(portalId) {
            const portal = AppModel.portals.find((portal) => portal.id === portalId);

            return portal.name;
        },
        getPortals() {
            return AppModel.portals;
        },
        getCampsites() {
            const emptyCampsite = {
                id: null,
                value: null,
                name: this.$t('portals.form.noSelection'),
            };
            const arr = [];

            // if(this.selectedPortalId !== null || true) {
            arr.push(emptyCampsite);
            // }

            let keys = Object.keys(AppModel.campsiteTypes);
            keys.forEach(key => {
                let e = {id: -1,
                    value: key,
                    name: '-- ' + this.$t('generic.campsite_types.' + key + '.portal_select_name') + ' --'};
                arr.push(e);
            });

            arr.push(...this.campsites);

            return arr;
        },
        getCampsiteName(campsiteId, accoMaintype) {
            const campsite = this.campsites.find((campsite) => campsite.id === campsiteId);
            if(!campsite && accoMaintype) {
                return this.$t('generic.campsite_types.' + accoMaintype + '.portal_select_name');
            }

            return campsite ? campsite.name : this.$t('generic.campsite_types.all.portal_select_name');
        },
        getDate(validFrom, validTo) {
            const from = validFrom ? moment(validFrom).format('L') : '';
            const to = validTo ? moment(validTo).format('L') : '';

            return from && to ? `${from} - ${to}` : '';
        },
        async savePortal() {
            const data = {
                campground_slug: AppModel.activeCampground.slug,
                portal_id: this.form.portal.value[ this.form.portal.valueKey ],
                campsite_id: this.form.campsite.value ? this.form.campsite.value[ this.form.campsite.valueKey ] : null,
                valid_from: this.form.valid_from.isHidden ? null : this.form.valid_from.value,
                valid_to: this.form.valid_to.isHidden ? null : this.form.valid_to.value,
                allotment: this.form.allotment.isHidden ? null : this.form.allotment.value,
            };

            if(data.campsite_id === -1) {
                data.campsite_id = null;
                data.accommodation_maintype = this.form.campsite.value['value'];
            }

            if(this.isEditMode) {
                await Api.portalMembers.update(this.selectedPortalId, data);
            } else {
                const { response } = await Api.portalMembers.create(data);

                if(response.status >= 400) {
                    EventBus.$emit(EventBus.SHOW_NOTIFICATION, {
                        title: `<h3>${this.$t('generic.formErrorHeadline')}</h3>`,
                        direction: 'Up',
                        type: 'danger',
                        body: response.data[ 'non_field_errors' ][ 0 ],
                    });
                }
            }

            await this.fetchCampgroundPortals();
            this.toggleModal();
        },
        toggleModal() {
            this.showModal = !this.showModal;

            if(!this.showModal) {
                this.resetForm();
                this.isEditMode = false;
                this.selectedPortalId = null;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import './src/variables';

.portals {
    &__form-field {
        position: relative;
    }

    &__date {
        cursor: pointer;
    }

    &__date-picker {
        position: absolute;
        top: 110%;
        border: 1px solid $gray-80;
        z-index: 1;
    }

    &__table-toolbar {
        display: flex;
        justify-content: flex-end;
    }

    &__table-edit {
        text-align: center;

        i {
            cursor: pointer;
        }
    }

    .modal-card {
        width: 50%;
        max-width: 800px;
        min-height: 45rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/portals/portals.vue